import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectDeepfakeAlertTimestamp } from 'containers/Alerts/selectors'

import DeepfakeAlertModal from './DeepfakeAlertModal'

const DeepfakeNotificationsManager = () => {
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false)
  const [hasShownAlert, setHasShownAlert] = useState(false)
  const alertTimestamp = useSelector(selectDeepfakeAlertTimestamp)

  // Show alert when we get a new timestamp and haven't shown it yet
  useEffect(() => {
    if (alertTimestamp && !hasShownAlert) {
      setIsAlertModalOpen(true)
      setHasShownAlert(true)
    }
  }, [alertTimestamp, hasShownAlert])

  // Reset hasShownAlert when timestamp changes (new alert)
  useEffect(() => {
    if (alertTimestamp) {
      setHasShownAlert(false)
    }
  }, [alertTimestamp])

  // Handle alert modal close
  const handleAlertClose = () => {
    setIsAlertModalOpen(false)
  }

  return <DeepfakeAlertModal isOpen={isAlertModalOpen} onClose={handleAlertClose} />
}

export default DeepfakeNotificationsManager
